import ChatMedia from "./ChatMedia";
import FileList from "./FileList";
import ChatTime from "./ChatTime";
import ChatActionsDropdown from "./ChatActionsDropdown";
import _ from "lodash";

const ChatContent = ({
  chat,
  chatMessages,
  key,
  activeTab,
  currentUser,
  formatDate,
  handleForwardCLick,
  deleteMessage,
  isGroup = false,
  editHandler = () => { },
}) => {
  const isSender = chat.sender === currentUser._id;
  const isImage = chat?.media?.[0]?.fileType?.startsWith("image");
  const isAudio = chat?.media?.[0]?.fileType === "audio/webm";
  const isOtherFile = chat?.media?.[0] && !isImage && !isAudio;
  const isEdited = new Date(chat.updatedAt) > new Date(chat.createdAt);

  return (
    <>
      {isEdited && <small
        className="text-muted fst-italic mutedText"
      >
        Edited
      </small>}
      <div className="ctext-wrap">
        <div
          className={
            chatMessages[key]?.forwardedBy
              ? "ctext-wrap-content border-l-2 border-solid border-blue-300"
              : "ctext-wrap-content"
          }
        >
          {/* ✅ Message Text */}
          {chat.message && (
            <div
              className={`d-inline-block p-2 rounded bg-white text-dark ${isSender
                ? "align-self-end"
                : "align-self-start"
                }`}
            >
              <p className="mb-0">{chat.message}</p>
            </div>
          )}

          {/* ✅ Media */}
          {chat.media && chat.media.length > 0 && (
            <>
              {isImage ? (
                <ChatMedia media={chat.media} />
              ) : isAudio ? (
                <div>
                  <audio controls>
                    <source
                      src={`${process.env.REACT_APP_API_URL}/${chat?.media[0]?.filePath}`}
                      type="audio/webm"
                    />
                    Your browser does not support the audio element.
                  </audio>
                </div>
              ) : (
                isOtherFile && (
                  <div className="flex justify-between items-center">
                    <span className="text-md text-grey-800">
                      {chat?.media[0]?.fileName}
                    </span>
                    <a
                      className="px-2"
                      href={`${process.env.REACT_APP_API_URL}/${chat?.media[0]?.filePath}`}
                      download
                    >
                      <i
                        className="ri-download-cloud-2-line text-xl"
                        style={{ marginTop: 4 }}
                      ></i>
                    </a>
                  </div>
                )
              )}
            </>
          )}

          {/* ✅ File Message */}
          {chat.fileMessage && (
            <FileList fileName={chat.fileMessage} fileSize={chat.size} />
          )}

        </div>

        {/* ✅ Actions Dropdown */}
        {!chat.isTyping && (
          <ChatActionsDropdown
            chat={chat}
            message={chat.message}
            handleForwardCLick={handleForwardCLick}
            chatMessages={chatMessages}
            index={key}
            deleteMessage={deleteMessage}
            isGroup={isGroup}
            currentUser={currentUser}
            editHandler={editHandler}
          />
        )}
      </div>
      <ChatTime updatedAt={chat.updatedAt} formatDate={formatDate} />
    </>
  );
};

export default ChatContent;
